// extracted by mini-css-extract-plugin
export default {"cls1":"useAttachment-cls1__efa0f9185d263ee5db5c","cls2":"useAttachment-cls2___1983159735d346d3d4c useAttachment-cls1__efa0f9185d263ee5db5c"};